module.exports = __webpack_public_path__ + "static/media/solution-tube-k-closed.471fc812.svg";